import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@teo/components';
import { Training, Evaluation, Import } from '@teo/components/icons';
import { LearningPathSidebarAdd } from '@/constants/sidebar.constants';
import { AuthContext } from '@/components/Contexts/AuthContext';

const ThemeActionLP = ({
  nodeSelected,
  authUser,
  setSelectedCourseType,
  setIsOpenListCoursesModal,
  handleAddTrainingTheme,
}) => {
  const { t } = useTranslation();

  const courseType = authUser?.useCourse;
  const assessmentType = authUser?.useAssessment;
  const vacancyType = authUser?.useLeervacature;
  const instructionType = authUser?.useInstruction;

  return (
    <div className="border-t p-5">
      <h4 className="mb-3 text-base">
        {t('pages.learning_path.actions_label')}
      </h4>
      <div className="flex flex-col gap-2">
        {LearningPathSidebarAdd?.map((el, i) => {
          if (!courseType && el?.type === 'course') return null;
          if (!assessmentType && el?.type === 'assessment') return null;
          if (!vacancyType && el?.type === 'leervacature') return null;
          if (!instructionType && el?.type === 'instruction') return null;
          return (
            <div key={i}>
              <Button
                onClick={() => {
                  setSelectedCourseType(el.type);
                  setIsOpenListCoursesModal(true);
                }}
                variant="ghost"
                className="flex gap-2 !px-3"
              >
                <el.icon
                  className={`h-5 w-5 fill-black ${
                    el?.type === 'leervacature' && 'text-black'
                  }`}
                />
                {t(el.text_add)}
              </Button>
            </div>
          );
        })}
        <div>
          <Button
            variant="ghost"
            className="flex gap-2 !px-3"
            onClick={() => handleAddTrainingTheme('training')}
          >
            <Training className="text-black" />
            {t('pages.learning_path.add_training')}
          </Button>
        </div>
        <div>
          <Button
            variant="ghost"
            className="flex gap-2 !px-3"
            onClick={() => handleAddTrainingTheme('evaluation')}
          >
            <Evaluation className="text-black" />
            {t('pages.learning_path.add_evaluation')}
          </Button>
        </div>
        <div>
          <Button
            variant="ghost"
            className="flex gap-2 !px-3"
            onClick={() => {}}
          >
            <Import className="text-black" />
            {t('pages.learning_path.import_external')}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default ThemeActionLP;
